module.exports = __webpack_public_path__ + "img/tab-bets-inactive.f6053256.png";